// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2552) return "static/chunks/2552-f8f63a28ff42a26d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6990 ? "0b6ffb98" : chunkId) + "." + {"4206":"9ffdfc545390857e","6990":"a542af064b53647d","7697":"73376655d56a76f9"}[chunkId] + ".js";
};